import { render, staticRenderFns } from "./Barcode.vue?vue&type=template&id=51679b83&scoped=true&"
import script from "./Barcode.vue?vue&type=script&lang=js&"
export * from "./Barcode.vue?vue&type=script&lang=js&"
import style0 from "./Barcode.vue?vue&type=style&index=0&id=51679b83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51679b83",
  null
  
)

export default component.exports